export default __webpack_public_path__ + "static/media/silka-regular-webfont.7910eb8b.eot";